const flattenNodes = arr => arr?.edges?.map(({ node }) => node);

export default flattenNodes;
